// extracted by css-extract-rspack-plugin
export default {"corporateDonationWrapper":"CorporateDonationContainer_corporateDonationWrapper__3uvmt"};